module.exports = __webpack_public_path__ + "img/img-related02.879f746c.jpg";